import TestimonialView from "./testimonialView";

const TestimonialLayout = () => {
    return (
        <>
            <TestimonialView />
        </>
    );
}

export default TestimonialLayout;